module.exports = __webpack_public_path__ + "media/images/flags/gl-a7000fb4004c1d6aeec60dd3f6d4fd65.svg";